"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = addCsrfToken;
const uuid_1 = require("uuid");
function addCsrfToken(req, res, next) {
    const csrfToken = (0, uuid_1.v4)();
    req.session.csrfToken = csrfToken;
    res.cookie('_csrf', csrfToken);
    next();
}
